/**
 * A classname to apply to an element that should be offset either with padding
 * or margin by the height of a normal App Bar.
 */
export var APP_BAR_OFFSET_CLASSNAME = "rmd-app-bar-offset";
/**
 * A classname to apply to an element that should be offset either with padding
 * or margin by the height of a dense App Bar.
 */
export var APP_BAR_OFFSET_DENSE_CLASSNAME = "rmd-app-bar-offset--dense";
/**
 * A classname to apply to an element that should be offset either with padding
 * or margin by the height of a prominent App Bar.
 */
export var APP_BAR_OFFSET_PROMINENT_CLASSNAME = "rmd-app-bar-offset--prominent";
/**
 * A classname to apply to an element that should be offset either with padding
 * or margin by the height of a prominent and dense App Bar.
 */
export var APP_BAR_OFFSET_PROMINENT_DENSE_CLASSNAME = "rmd-app-bar-offset--prominent-dense";
//# sourceMappingURL=constants.js.map